module.exports = __webpack_public_path__ + "img/KL_LOGO_CONTACT.39d54f7a.svg";